export default __webpack_public_path__ + "static/5-d04c4f5195b4c31b613376c8800cb830.jpg";